// Init
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../config';

const instance = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
});

instance.interceptors.request.use((config) => {
  let token = localStorage.getItem('Brandtoken');
  if (!token) {
    token = localStorage.getItem('token');
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (res) => res.data,
  (err) => {
    if (err?.response?.status === 429) {
      toast.error(err?.response?.data?.message || 'Too many requests. Please slow down and try again.');
    } else if (err?.response?.status === 403) {
      const msg = (err?.response?.data?.message || '').toLowerCase();
      // Only treat true session failures as auth failures. A 403 with
      // "not authorized to access this resource" means the JWT verifies fine
      // but the role/scope is wrong — that's a permission error and should
      // NOT log the user out (was previously kicking admins mid-session).
      //  - "No token found, Authorization denied"   (missing header → real logout)
      //  - "Your session has been expired"          (jwt.verify threw → real logout)
      const isAuthFailure =
        msg.includes('no token found')
        || msg.includes('session has been expired');
      if (err?.response?.data?.requiresPin || err?.response?.data?.notOwner) {
        // PIN or ownership check — let caller handle
      } else if (isAuthFailure) {
        // Token invalid/expired — logout
        localStorage.removeItem('token');
        localStorage.removeItem('Brandtoken');
        window.location = '/auth/login';
      } else {
        // Permission denied but not an auth issue — don't logout
        console.warn('403 Permission denied:', err?.response?.data?.message);
      }
    } else {
      console.error('API Error:', err?.response?.data?.message || err?.message);
      toast.error(err?.response?.data?.message || err?.message);
    }
    return Promise.reject(err);
  }
);

// Backward-compatible wrapper: api('get', '/url') or api('post', '/url', body)
const api = (method, url, body) => {
  return instance[method](url, body);
};

// Export
export default api;
